module.exports = __webpack_public_path__ + "img/制御工学1_4.5f3d2a27.png";